import styled from "styled-components/macro";
import { darkBlue, lightText } from "../../constants/colors";
import {
  FONT_SIZE_SMALL,
  FONT_SIZE_MEDIUM,
  BREAKPOINT_MUI_NAV_SHRINK_8_PX,
  FONT_SIZE_LARGE,
  BREAKPOINT_DESKTOP_XL,
  NAV_HEIGHT_PX,
} from "../../constants/constants";

const ELEMENT_SIZE_LG = 32;
const ELEMENT_SIZE = 24;
const ELEMENT_MARGIN = 0;

export const TopBarStyles = styled.div<{
  $isIE: boolean;
}>`
  position: relative;

  .root {
    background-color: ${darkBlue};
    color: ${lightText};
    .toolbar {
      display: flex;
      padding: 0 8px;
    }
  }
  .backArrow {
    font-size: ${FONT_SIZE_LARGE}px;
    color: ${lightText};
  }
  .avatar {
    border: 1px solid white;
    width: ${ELEMENT_SIZE}px;
    height: ${ELEMENT_SIZE}px;
    margin: ${ELEMENT_MARGIN}px;
  }
  .avatarPlaceholder {
    width: ${ELEMENT_SIZE + 2 * ELEMENT_MARGIN}px;
  }
  .name {
    display: flex;
    align-items: center;
    font-size: ${ELEMENT_SIZE}px;
    color: ${lightText};
  }
  .rightDrawerButton {
    font-size: ${ELEMENT_SIZE}px;
    justify-content: end;
  }
  .spacer {
    flex-grow: 1;
  }
  button {
    text-transform: none;
  }
  .departmentName {
    font-size: ${FONT_SIZE_SMALL}px;
    white-space: nowrap;
    min-height: 42px;
    display: flex;
    align-items: center;
  }
  .btnDropDown {
    color: ${lightText};
    overflow: visible;
    justify-content: flex-start;
  }
  .backArrowAndNameLink {
    text-decoration: none;
    text-decoration-line: none;
    width: 0;
    padding-right: 80px;
    margin-right: -80px;
    position: absolute;
    left: 56px;
    top: 0;
    bottom: 0;
    transition: all 0.3s;
  }
  .backButtonWrapper {
    z-index: 1;
    padding: 8px 1em;
    text-transform: none;
    height: 100%;
    color: ${lightText};
    display: flex;
    align-items: center;
    overflow: visible;
  }
  .linkContainer {
    padding: 0 8px;
  }
  @media (min-width: ${BREAKPOINT_MUI_NAV_SHRINK_8_PX}px) {
    .departmentName {
      font-size: ${FONT_SIZE_MEDIUM}px;
    }
    .avatar {
      width: ${ELEMENT_SIZE_LG}px;
      height: ${ELEMENT_SIZE_LG}px;
    }
    .avatarPlaceholder {
      width: ${ELEMENT_SIZE_LG + 2 * ELEMENT_MARGIN}px;
    }
    .name {
      font-size: ${ELEMENT_SIZE_LG}px;
    }
    .rightDrawerButton {
      font-size: ${ELEMENT_SIZE_LG}px;
    }
  }
  @media (min-width: ${BREAKPOINT_DESKTOP_XL}px) {
    .backButtonWrapper {
      padding-left: 2.4em;
    }
    .toolbar {
      height: ${NAV_HEIGHT_PX * 1.5}px;
    }
    .departmentName {
      font-size: ${FONT_SIZE_MEDIUM * 1.5}px;
    }
    .backArrowAndNameLink {
      margin-left: 24px;
    }
    .avatar {
      width: ${ELEMENT_SIZE_LG * 1.5}px;
      height: ${ELEMENT_SIZE_LG * 1.5}px;
    }
    .avatarPlaceholder {
      width: ${(ELEMENT_SIZE_LG + 2 * ELEMENT_MARGIN) * 1.5}px;
    }
    .name {
      font-size: ${ELEMENT_SIZE_LG * 1.5}px;
    }
    .rightDrawerButton {
      font-size: ${ELEMENT_SIZE_LG * 1.5}px;
    }
    .MuiIconButton-root {
      height: ${NAV_HEIGHT_PX * 0.75}px;
    }
    [class*="RavenLogoStyles"] {
      height: ${NAV_HEIGHT_PX * 1.5}px;
      .linkContainer {
        transform: scale(2);
      }
    }
    [class*="WifiBarsStyles"] {
      transform: scale(1.5) translateX(-12px);
      transform-origin: right;
    }
    &&&& {
      .btnLeftDrawer {
        top: 0px;
        left: 0px;
        height: ${NAV_HEIGHT_PX * 1.5}px;
        width: ${NAV_HEIGHT_PX * 1.5}px;
        .MuiSvgIcon-root {
          height: ${NAV_HEIGHT_PX * 0.75}px;
          width: ${NAV_HEIGHT_PX * 0.75}px;
        }
      }
      .btnRightDrawer {
        top: 0px;
        right: 0px;

        height: ${NAV_HEIGHT_PX * 1.5}px;
        width: ${NAV_HEIGHT_PX * 1.5}px;
      }
    }
    [aria-label="Switch processes"] .MuiButton-endIcon {
      right: -24px;
      transform: scale(2);
    }
  }
  .btnRightDrawer {
    position: absolute;
    right: ${props => (props.$isIE ? 16 : 8)}px;
    bottom: 8px;
    top: 8px;
    @media (max-width: ${BREAKPOINT_MUI_NAV_SHRINK_8_PX}px) {
      top: 4px;
    }

    /* if we support overflow: overlay, add scrollbar width to padding-right so we don't fall behind the scrollbar */
    @supports (overflow: overlay) {
      /* disable for mobile, where scrollbar is invisible */
      @media (min-width: ${BREAKPOINT_MUI_NAV_SHRINK_8_PX}px) {
        right: 16px;
      }
    }
  }
  .btnLeftDrawer {
    position: absolute;
    z-index: 1;
    bottom: 8px;
    top: 8px;
    @media (max-width: ${BREAKPOINT_MUI_NAV_SHRINK_8_PX}px) {
      top: 4px;
    }
  }

  @media print {
    .root {
      height: 0.5in !important;
    }
    .backButtonWrapper {
      display: none;
    }
    .btnRightDrawer {
      display: none;
    }
  }
`;
